module.exports = __webpack_public_path__ + "img/DE01335.c2b90ec1.png";